import { useEffect } from 'react'

import { useAppDispatch } from '@/utils/typeHelpers'
import { fetchUserDocumentCategoriesIfNeeded } from '@/features/admin/user-document-categories/userDocumentCategories.slice'
import { fetchUserDocuments } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { Form2553UploadItem } from '../shared/Form2553UploadItem'
import { FormCP261UploadItem } from '../shared/FormCP261UploadItem'
import { FormIncorporationDocumentUploadItem } from '../shared/FormIncorporationDocumentUploadItem'
import { FormEinLetterUploadItem } from '../shared/FormEinLetterUploadItem'
import { FormStateRegistrationUploadItem } from '../shared/FormStateRegistrationUploadItem'

interface IDocumentUploads {
  businessEntity?: string
  isScorp?: boolean
}

export const DocumentUploads = ({
  businessEntity,
  isScorp,
}: IDocumentUploads) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchUserDocuments())
    dispatch(fetchUserDocumentCategoriesIfNeeded())
  }, [dispatch])

  if (isScorp) {
    return (
      <>
        <Form2553UploadItem businessEntity={businessEntity} />
        <FormCP261UploadItem businessEntity={businessEntity} />
        <FormIncorporationDocumentUploadItem businessEntity={businessEntity} />
      </>
    )
  }

  return (
    <>
      <FormEinLetterUploadItem
        businessEntity={businessEntity}
        uploadButtonOnly
      />
      <FormStateRegistrationUploadItem
        businessEntity={businessEntity}
        uploadButtonOnly
      />
    </>
  )
}
